import { getBirthdateValidationError } from './validate-birthdate';
import { bindDobDisclaimerValidation } from './validate-dob-disclaimer';

export default function initAccountDetailsForm() {
  function validateBirthdate() {
    const dayInput = document.getElementById('dob-day');
    const monthInput = document.getElementById('dob-month');
    const yearInput = document.getElementById('dob-year');
    const hiddenInput = document.getElementById('DateOfBirth');
    const errorEl = document.querySelector('[data-valmsg-for="DateOfBirth"]');
    const errorIcon = document.getElementById('dob-validation-icon');

    const day = dayInput.value;
    const month = monthInput.value;
    const year = yearInput.value;
    const inputs = [dayInput, monthInput, yearInput];

    const errorMessage = getBirthdateValidationError(day, month, year);
    if (errorMessage) {
      errorEl.textContent = errorMessage;
      errorEl.classList.add('field-validation-error');
      hiddenInput.value = '';
      if (errorIcon) errorIcon.classList.remove('at-d-none');
      inputs.forEach((input) => input.classList.add('input-validation-error'));
    } else {
      errorEl.textContent = '';
      errorEl.classList.remove('field-validation-error');

      const formattedDay = String(day).padStart(2, '0');
      const formattedMonth = String(month).padStart(2, '0');
      hiddenInput.value = `${formattedDay}/${formattedMonth}/${year}`;

      if (errorIcon) errorIcon.classList.add('at-d-none');
      inputs.forEach((input) => input.classList.remove('input-validation-error'));
    }
  }

  function bindDateOfBirthListeners() {
    ['dob-day', 'dob-month', 'dob-year'].forEach((id) => {
      const input = document.getElementById(id);
      if (!input) return;

      input.addEventListener('blur', validateBirthdate);
      input.addEventListener('keypress', (e) => {
        const char = String.fromCharCode(e.which || e.keyCode);
        if (!/\d/.test(char)) e.preventDefault();
      });
      input.addEventListener('paste', (e) => {
        const paste = (e.clipboardData || window.clipboardData).getData('text');
        if (!/^\d+$/.test(paste)) e.preventDefault();
      });
    });
  }

  function prefillDateOfBirthFromHiddenInput() {
    const value = document.getElementById('DateOfBirth').value;
    const match = value.match(/^(\d{1,2})\/(\d{1,2})\/(\d{4})/);
    if (match) {
      const [, day, month, year] = match;
      document.getElementById('dob-day').value = String(day).padStart(2, '0');
      document.getElementById('dob-month').value = String(month).padStart(2, '0');
      document.getElementById('dob-year').value = year;
    }
  }

  function setupAddressToggle() {
    const addressToggleBtn = document.getElementById('toggle-manual-address');
    const manualFields = document.getElementById('manual-address-fields');

    addressToggleBtn.addEventListener('click', (e) => {
      e.preventDefault();
      manualFields.classList.toggle('visible');

      const useEl = addressToggleBtn.querySelector('svg use');
      const isVisible = manualFields.classList.contains('visible');
      useEl.setAttribute('href', isVisible ? '#icon-chevron-up' : '#icon-chevron-down');
    });
  }

  document.addEventListener('DOMContentLoaded', () => {
    const form = document.getElementById('my-preferences-form');
    const fieldset = document.getElementById('AT_My_Preferences');
    const spinner = document.getElementById('save-spinner');

    bindDateOfBirthListeners();
    prefillDateOfBirthFromHiddenInput();
    setupAddressToggle();

    const dobDisclaimer = bindDobDisclaimerValidation(form);

    fieldset.disabled = false;

    form.addEventListener('submit', (e) => {
      if (e.submitter?.value === 'Cancel') return;

      if (dobDisclaimer.bound && !dobDisclaimer.isValid()) {
        e.preventDefault();
        return;
      }

      validateBirthdate();
      const errorEl = document.querySelector('[data-valmsg-for="DateOfBirth"]');
      if (errorEl && errorEl.textContent.trim() !== '') {
        e.preventDefault();
        errorEl.scrollIntoView({ behavior: 'smooth', block: 'center' });
        return;
      }

      if (!$('#my-preferences-form').validate().form()) return;

      spinner.classList.remove('at-d-none');
      // Prevent disabling the fieldset before form submission
      requestAnimationFrame(() => {
        fieldset.disabled = true;
      });
    });
  });
}
